import { render } from "./ArgonBadge.vue?vue&type=template&id=12b8c86e"
import script from "./ArgonBadge.vue?vue&type=script&lang=js"
export * from "./ArgonBadge.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__